// Detects when the coach portal is open in more than one browser tab for two
// DIFFERENT coaches - e.g. office staff impersonating two coaches at once, which
// the portal was never designed for and causes session cross-contamination - and
// blocks both tabs with an overlay. Two tabs open for the SAME coach (e.g.
// working on pairs and assessments side by side) are left alone.
//
// There's no reliable way to know which coach a tab belongs to before it has
// logged in / been impersonated (the coach UUID is never in the URL for normal
// browsing), so unlike a plain single-tab lock this can't gate mounting -
// instead every tab announces its coach identity once it knows it (see
// announceCoach, called from Home's componentDidMount, which runs on every
// authenticated page load: fresh login, fresh impersonation, and reloads
// alike), and any two tabs that turn out to disagree block each other.
const CHANNEL_NAME = 'aephoria-coachportal-tab-channel';
const MESSAGE = "The coach portal has just been opened in another tab for a different coach. Working in two tabs at once for different coaches isn't supported and will cause problems - please close one of the tabs, then reload the other.";

let channel = null;
let myCoachUUID = null;
let blocked = false;

function getChannel() {
  if (!channel && ('BroadcastChannel' in window)) {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event) => {
      const data = event.data || {};
      if (data.type === 'announce' && data.coachUUID && myCoachUUID && data.coachUUID !== myCoachUUID) {
        channel.postMessage({ type: 'conflict' });
        block();
      } else if (data.type === 'conflict') {
        block();
      }
    };
  }
  return channel;
}

export function announceCoach(coachUUID) {
  if (!coachUUID || blocked)
    return;
  myCoachUUID = coachUUID;
  const ch = getChannel();
  if (ch)
    ch.postMessage({ type: 'announce', coachUUID });
}

function block() {
  if (blocked)
    return;
  blocked = true;
  showBlockOverlay();
}

function showBlockOverlay() {
  const overlay = document.createElement('div');
  overlay.setAttribute('style', 'position:fixed; inset:0; z-index:2147483647; background:rgba(30,34,38,0.92); display:flex; align-items:center; justify-content:center; padding:24px; font-family:Arial,Helvetica,sans-serif;');
  const box = document.createElement('div');
  box.setAttribute('style', 'background:#ffffff; border-radius:8px; max-width:420px; width:100%; padding:28px 32px; text-align:center; box-shadow:0 10px 40px rgba(0,0,0,0.3);');
  box.innerHTML =
    '<h3 style="margin:0 0 12px; color:#1b1e1c;">Already open in another tab</h3>' +
    '<p style="margin:0 0 20px; color:#4a4f4c; line-height:1.5;">' + MESSAGE + '</p>' +
    '<button type="button" style="background:#337ab7; color:#fff; border:none; border-radius:4px; padding:10px 20px; font-size:14px; cursor:pointer;">Reload this page</button>';
  box.querySelector('button').addEventListener('click', () => window.location.reload());
  overlay.appendChild(box);
  document.body.appendChild(overlay);
}
